<template>
    <div class="navigation" v-bind:class="{ 'is-active' : isActive }">
        <div class="navigation__items">
            <a class="navigation__item navigation__item--profile" href="/my-profile" v-if="user">
                Profile details
            </a>
            <a class="navigation__item navigation__item--payments" href="/subscription" v-if="user">
                Payments/plan
            </a>
            <a class="navigation__item navigation__item--faq" href="/faq">
                FAQ
            </a>
            <a class="navigation__item navigation__item--contact" href="/contact">
                Support/Contact
            </a>
            <a class="navigation__item navigation__item--terms" href="/terms-of-use">
                Privacy & Terms of Use
            </a>
            <a class="navigation__item navigation__item--logout" href="/logout" v-if="user">
                Logout
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isActive: {
                required: true,
                type: Boolean
            }
        }
    }
</script>
